<template>
    <b-container fluid style="margin-bottom: 20px">
        <b-row>
            <b-col cols="1">
                <p v-if="search.type === 'PRIMARY'"></p>
                <b-form-select v-else
                    :value="search.type"
                    :options="options_type"
                    @input="editField('type', $event)">

                </b-form-select>
            </b-col>
            <b-col cols="2">
                <b-form-select
                        :value="search.table"
                        :options="options_table"
                        @input="editField('table', $event)">

                </b-form-select>
            </b-col>
            <b-col cols="2">
                <b-form-select
                    :value="search.column"
                    :options="options_column"
                    @input="editField('column', $event)">

                </b-form-select>
            </b-col>
            <b-col cols="2">
                <b-input
                    :value="search.value"
                    @input="editField('value', $event)">

                </b-input>
            </b-col>
            <b-col cols="2">
                <b-form-select
                    :value="search.operation"
                    :options="options_operation"
                    @input="editField('operation', $event)">

                </b-form-select>
            </b-col>
            <b-col cols="1">
                <b-form-checkbox
                    :checked="search.negative"
                    @input="editField('negative', $event)">
                </b-form-checkbox>
            </b-col>
            <b-col cols="2">
                <b-btn style="margin-right: 25%" @click="addField">+</b-btn>
                <b-btn v-if="search.type !== 'PRIMARY' " @click="deleteField">-</b-btn>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    const OPERATION_DICT = {
        'eq': 'Equal',
        'more': 'More',
        'contains': 'Contains'
    };
    export default {
        name: "SearchField",
        props: ['search', 'index', 'config'],
        data() {
            return {

                options_type: ['AND', 'OR']
            }
        },
        computed: {
            options_table() {
                let a = [];
                for (const key in this.config) {
                    if (this.config.hasOwnProperty(key)){
                        a.push({value: key, text: this.config[key]['desc']})
                    }
                }
                return a;
            },
            options_column() {
                let a = [];
                if (this.config == null ||
                    !this.config.hasOwnProperty(this.search.table)) {
                    return a;
                }
                const current_table = this.config[this.search.table];
                for (const key in current_table) {
                    if (current_table.hasOwnProperty(key)){
                        if (key === 'desc') {
                            continue;
                        }
                        a.push({value: key, text: current_table[key]['desc']})
                    }
                }
                return a
            },
            options_operation() {
                let a = [];
                if (this.config == null ||
                    !this.config.hasOwnProperty(this.search.table)
                    || !this.config[this.search.table].hasOwnProperty(this.search.column)) {
                    return a;
                }
                const current_table = this.config[this.search.table][this.search.column];
                for (const key in current_table) {
                    if (current_table.hasOwnProperty(key)){
                        if (key === 'desc') {
                            continue;
                        }
                        a.push({value: key, text: OPERATION_DICT.hasOwnProperty(key)
                                ? OPERATION_DICT[key]
                                : key})
                    }
                }
                return a
            }
        },
        methods: {
            editField(prop, value) {
                const { search } = this;
                this.$store.dispatch('edit_property', {search, prop, value})

            },

            // eslint-disable-next-line no-unused-vars
            deleteField(value) {
                // eslint-disable-next-line no-console
                const { search } = this;
                this.$store.dispatch('delete_search', search)
            },

            // eslint-disable-next-line no-unused-vars
            addField(value) {
                const { search } = this;
                this.$store.dispatch('add_search', search)
            }
        }
    }
</script>

<style scoped>

</style>